/** @format */

import { PromoBanner } from '@/components/shared/PromoBanner';
import { TRoom } from '@/ducks/room/declarations';
import { TLocale } from '@/utils/gatsby/types';
import React, { memo, useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { useAppTranslation } from '../../../../../i18n/declarations';
import { PromoBannerContainer, TextPromoBanner } from '../../../../shared/PromoBanner/PromoBanner.style';
import DesktopBookCard from './Desktop';
import FixedNavbar from './FixedNavbar';

interface Props {
  locale: TLocale;
  room: TRoom;
  lite: boolean;
}

const BookCard = memo(({ locale, lite, room }: Props) => {
  const { intl } = useAppTranslation();

  const displayNoDepositBanner = useMemo(() => {
    if (room?.commercialConditions?.depositAmount === 0) {
      return true;
    }
    return false;
  }, [room?.commercialConditions?.depositAmount]);

  return (
    <NavContainer $lite={lite ?? false}>
      {displayNoDepositBanner && (
        <PromoBannerContainer $page="pdp" $layout="desktop">
          <TextPromoBanner>{intl.formatMessage({ id: 'pdp.promo_no_deposit' })}</TextPromoBanner>
        </PromoBannerContainer>
      )}
      <PromoBanner
        page={'pdp'}
        layout={'desktop'}
        promoBannerInfo={{
          buildingId: room.building.id ?? null,
          bedCode: room.code ?? null,
          flatId: room.flat.id ?? null,
          cityId: room.city.id ?? null,
        }}
      />
      <DesktopBookCard room={room} locale={locale} />
      <FixedNavbar locale={locale} room={room} />
    </NavContainer>
  );
});

export default BookCard;

export const NavContainer = styled.div<{ $lite: boolean }>`
  width: 100%;
  height: 100%;
  position: relative;
  display: block;
`;
